export function getPath(location) {
    const pathArray = location.pathname.split("/")
    if (pathArray.length === 0) {
        return ""
    }
    return pathArray[pathArray.length - 1]
}
export function addHyphen(string = "") {
    if (!string) return ""
    return replace_(string, " ", "-")
}
export function removeHyphen(string = "") {
    if (!string) return ""
    return replace_(string, "-", " ")
}

function replace_(string, o, n) {
    if (!string) return ""
    if (!o || !n) return string
    let result = string
    while (result.includes(o)) {
        result = result.replace(o, n)
    }
    return result
}